import {FontAwesomeIcon as Icon} from "@fortawesome/react-fontawesome"
import {Vehicle} from "domain-models"
import React from "react"
import {number, vehicleAttribute} from "../../../../../filters"
import Trans from '../../../../../components/Trans'

type EngineProps = {
  vehicle: Vehicle
}

class Engine extends React.Component<EngineProps> {
  render() {
    const vehicle = this.props.vehicle
    return (
      <div className="w-full flex flex-row flex-wrap mt-10 md:mt-0 text-gray-700">
        <span className='font-semibold text-lg text-gray-700 w-full'>
          <Icon icon={['fas', 'tachometer-alt']}/> <Trans>Motor</Trans>
        </span>

        <div className='flex flex-row flex-wrap w-full'>
          <span className='w-1/2 md:w-1/3 truncate flex flex-col mt-1'>
            <span className="text-gray-600 font-normal fa-fw"><Trans>Motor</Trans></span>
            <span className="font-semibold text-gray-800">{vehicleAttribute('Engine', vehicle.Engine)}</span>
          </span>

          <span className='w-1/2 md:w-1/3 truncate flex flex-col mt-1'>
            <span className="text-gray-600 font-normal fa-fw"><Trans>Kraftstoff</Trans></span>
            <span className="font-semibold text-gray-800"><Trans>{vehicleAttribute('Fuel', vehicle.Fuel)}</Trans></span>
          </span>

          <span className='w-1/2 md:w-1/3 truncate flex flex-col mt-1'>
            <span className="text-gray-600 font-normal fa-fw"><Trans>Getriebe</Trans></span>
            <span className="font-semibold text-gray-800"><Trans>{vehicleAttribute('Transmission', vehicle.Transmission)}</Trans></span>
          </span>

          <span className='w-1/2 md:w-1/3 truncate flex flex-col mt-1'>
            <span className="text-gray-600 font-normal fa-fw"><Trans>Antrieb</Trans></span>
            <span className="font-semibold text-gray-800"><Trans>{vehicleAttribute('Drive', vehicle.Drive)}</Trans></span>
          </span>

          <span className='w-1/2 md:w-1/3 truncate flex flex-col mt-1'>
            <span className="text-gray-600 font-normal fa-fw"><Trans>Hubraum</Trans></span>
            <span className="font-semibold text-gray-800">{number(vehicle.Displacement, 0, 'ccm')}</span>
          </span>

          <span className='w-1/2 md:w-1/3 truncate flex flex-col mt-1'>
            <span className="text-gray-600 font-normal fa-fw"><Trans>Zylinder</Trans></span>
            <span className="font-semibold text-gray-800">{number(vehicle.NumCylinders, 0) || '-'}</span>
          </span>

          <span className='w-1/2 md:w-1/3 truncate flex flex-col mt-1'>
            <span className="text-gray-600 font-normal fa-fw"><Trans>Leistung</Trans></span>
            <span className="font-semibold text-gray-800">{number(vehicle.Power, 0, 'kw') || '-'}</span>
          </span>

          <span className='w-1/2 md:w-1/3 truncate flex flex-col mt-1'>
            <span className="text-gray-600 font-normal fa-fw"><Trans>Gänge</Trans></span>
            <span className="font-semibold text-gray-800">{number(vehicle.NumGears, 0) || '-'}</span>
          </span>

          <span className='w-1/2 md:w-1/3 truncate flex flex-col mt-1'>
            <span className="text-gray-600 font-normal fa-fw"><Trans>Tankinhalt</Trans></span>
            <span className="font-semibold text-gray-800">{number(vehicle.TankCapacity, 0) || '-'}</span>
          </span>
        </div>
      </div>
    )
  }
}

export default Engine
